import { useNavigate } from '@tanstack/react-router';

import { translate } from '../../helpers/translate.helper';
import { useRole } from '../../hooks/useRole';
import { IconPlus } from '../../icons/cdl/Plus';
import { useShortcutMenu } from '../hooks/useShortcutMenu';

import { CommandItem } from './CommandItem';

export const CreateEnquiry = () => {
    const navigate = useNavigate();
    const role = useRole();
    const { setOpen } = useShortcutMenu();

    if (!role.isCustomer() || !role.hasAnyCompanyWriteRights()) {
        return null;
    }

    return (
        <CommandItem
            onSelect={() => {
                navigate({ to: '/orders/new' });
                setOpen(false);
            }}
            Icon={IconPlus}
        >
            {translate('shortcutMenu.createEnquiry')}
        </CommandItem>
    );
};
